<script>
  import GalerieVideos from '@/components/GalerieVideos.vue'
  export default {
    name: 'Videos',
    data() {
      return {
        videos: [],
      }
    },
    mounted() {
      this.InitialiserDonnees()
    },
    methods: {
      async InitialiserDonnees() {
        const donneesBase = await fetch(
          'https://pascalchove.com/VideosService.php'
        )
        this.videos = await donneesBase.json()
        this.videos = this.videos.sort((a, b) => b.ordre - a.ordre)
      },
    },
    computed: {
      videosAAfficher() {
        return this.videos
      },
    },
    components: {
      GalerieVideos,
    },
  }
</script>

<template>
  <h2>LES VIDÉOS</h2>

  <GalerieVideos :donnees="videosAAfficher" categorie="videos" />
</template>
